const addScriptURLOnly = url => {
  const script = document.createElement("script")
  script.src = url
  script.async = true
  document.head.appendChild(script)
}
const addScriptData = data => {
  let url = data.url || ''
  // console.log("aaaaaaaaaaaaaa", data)
  const script = document.createElement("script")
  if(url)
  script.src = url
  script.type = "application/javascript";
  script.async = true;
   script.innerHTML = data.innerHtml
  script.nonce = 'abcdef'
  document.head.appendChild(script)
}

export const onClientEntry = () => {
  // console.log("22222222222222222222222222222222222222223333333333333333333333333333",process.env,process.env.DEVELOPMENT)
  window.onload = () => {
    if(process.env.DEVELOPMENT=='N')
    {
      addScriptURLOnly("https://www.googletagmanager.com/gtm.js?id=GTM-5G46XDD")
      addScriptData({
        innerHtml:`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5G46XDD');
      `})



      // addScriptData({
      //     innerHtml:`(function(h,o,t,j,a,r){
      //               h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      //               h._hjSettings={hjid:2571339,hjsv:6};
      //               a=o.getElementsByTagName('head')[0];
      //               r=o.createElement('script');r.async=1;    
      //               r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      //               a.appendChild(r);
      //         })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
      //     })
    }
      // console.log("checking mic")
      
   
          

  //   addScript("https://checkout.razorpay.com/v1/checkout.js")

  //   // addScript("https://www.tecprocesssolution.com/proto/P2M/server/lib/checkout.js")
  }

}